import { PaginateResult } from "core/resources/types/shared";
import { useQuery } from "react-query";
import axios from "infra/http";
import { VotacaoParticipanteVotanteItem, VotantesListagemQuery } from "../typings";

function useAssembleiaPessoasVotaram({idAssembleia, idPergunta, page, limit, search}: VotantesListagemQuery) {

  return useQuery([`/v1/votacao/${idAssembleia}/pergunta/${idPergunta}/votantes-${page}-${limit}-${search}`], async () => {
    const res = await axios.get<PaginateResult<VotacaoParticipanteVotanteItem>>(`/v1/votacao/${idAssembleia}/pergunta/${idPergunta}/votantes`, {
      params: {
        page,
        limit,
        search,
      },
    });

    return res.data;
  });
}

export default useAssembleiaPessoasVotaram;
